import { MtxButton } from '@meilleurtaux/mtp-uikit-react';

import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

import type { FC } from 'react';

interface InvestmentCardProps {
  icon: string;
  title: string;
  text: string;
  buttonLabel: string;
  route: string;
  trackingLabel: string;
}

const InvestmentCard: FC<InvestmentCardProps> = ({ icon, title, text, buttonLabel, route, trackingLabel }) => {
  const onClickDiscover = () => {
    globalThis.open(route, '_blank', 'noopener,noreferrer');

    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'placement',
      event_nom: 'decouvrir',
      event_detail_1: trackingLabel,
    });
  };

  return (
    <article className={styles.card}>
      <div className={styles.illustration}>
        <div className={styles.illustrationInner}>
          <img src={icon} alt="" />
        </div>
      </div>
      <div className={styles.textBlock}>
        <span className={styles.title}>{title}</span>
        <span className={styles.text}>{text}</span>
      </div>
      <div className={styles.buttonWrapper}>
        <MtxButton variant="primary" size="medium" fullWidth onClick={onClickDiscover}>
          <div>{buttonLabel}</div>
        </MtxButton>
      </div>
    </article>
  );
};

export default InvestmentCard;
